import {
  BadgeCheck,
  BookOpenCheck,
  CalendarDays,
  Globe,
  GraduationCap,
  HandCoins,
  Landmark,
  Megaphone,
  ShieldCheck,
  ShoppingBag,
  Smartphone,
  Users,
  Wallet,
} from 'lucide-react'
import type { Modul } from './tipler'

/**
 * Ürün modülleri — sitenin özellik sayfaları, ana sayfa ızgarası ve menü
 * buradan türer. Metin tonu docs/marka.md: siz dili, kısa, iddiasız; ünlem
 * ve pazarlama abartısı yok.
 *
 * `durum` dürüstlük içindir: hazır olmayan modül sitede "yakında" işaretiyle
 * durur, gizlenmez. Modül yayına girince yalnızca bu alan değişir.
 */
export const MODULLER: Modul[] = [
  {
    slug: 'uye-yonetimi',
    ad: 'Üye yönetimi',
    kisa: 'Başvurudan istifaya kadar bütün üyelik yaşam döngüsü tek kayıtta.',
    aciklama:
      'Her kişi bir kez kaydedilir; üyelik, aidat, katılım ve yazışma o kaydın altında birikir. Başvuru yönetim kurulu kararıyla üyeliğe döner, üyelik tipleri ve derneğinize özgü alanlar sizin tanımınızla çalışır.',
    ikon: Users,
    grup: 'cekirdek',
    durum: 'hazir',
    faz: 'Faz 1',
    ozellikler: [
      {
        baslik: 'Başvuru akışı',
        aciklama:
          'Üye portalından ya da panelden alınan başvuru "beklemede" durur; yönetim kurulu kararıyla aktif üyeliğe geçer. Ret gerekçesi kayda düşer.',
      },
      {
        baslik: 'Üyelik tipleri',
        aciklama:
          'Asil, fahri, öğrenci, kurumsal — her tipin kendi aidat tarifesi ve hakları vardır. Tip değişince tarife de değişir.',
      },
      {
        baslik: 'Size özel alanlar',
        aciklama:
          'Sicil no, oda kayıt no, mezuniyet yılı, kan grubu: üye formuna kendi alanlarınızı eklersiniz. Alan kodu değişmez; veri anlamını korur.',
      },
      {
        baslik: 'Durum geçişleri',
        aciklama:
          'Aktif, pasif, istifa, ihraç, vefat. Hangi durumdan hangisine geçilebileceği tanımlıdır; toplu işlemde sunucu satır satır rapor verir.',
      },
      {
        baslik: 'Excel ile içe aktarım',
        aciklama:
          'Mevcut üye listenizi CSV olarak yükleyin. Önce ön izleme yapılır, hiçbir satır yazılmaz; hatalı satırlar tek tek gösterilir.',
      },
      {
        baslik: 'Arama ve süzme',
        aciklama:
          'Ada, üye numarasına, e-postaya, duruma ve özel alanlara göre. Sayfalı liste büyük derneklerde de akıcı kalır.',
      },
      {
        baslik: 'Toplu işlemler',
        aciklama:
          'Seçili üyelerde durum değiştirme, etiketleme, e-posta gönderme. Her işlem denetim kaydına kimin yaptığıyla yazılır.',
      },
      {
        baslik: 'Üye kayıt defteri görünümü',
        aciklama:
          'Yönetmelikteki alanlarla hizalı liste ve dışa aktarım. Yasal defterin yerine geçmez; onu tutmanızı kolaylaştırır.',
      },
      {
        baslik: 'Şube ve federasyon yapısı',
        aciklama:
          'Şubeler kendi üyesini yönetir, genel merkez toplamı görür. Federasyon, üye derneklerinin sayısını ve aidatını tek ekrandan izler.',
      },
    ],
    senaryo: {
      baslik: 'Bir başvuru nasıl üye olur',
      metin: [
        'Aday, derneğin sitesindeki başvuru formunu doldurur. Kayıt panelde "başvuru" durumunda görünür; eksik belge varsa görevli not düşer.',
        'Yönetim kurulu toplantısında karar yazılır; karar numarası sırayla verilir. Başvuru aynı ekrandan aktif üyeliğe çevrilir, tarife otomatik bağlanır ve ilk aidat borcu oluşur.',
        'Üyeye hoş geldiniz e-postası ve portal daveti gider. Bundan sonra aidat, makbuz ve destek talepleri kendi hesabından görünür.',
      ],
    },
    mockup: 'uyeler',
    sss: [
      {
        soru: 'Üye sayısı sınırı var mı?',
        cevap:
          'Plana göre değişir: Başlangıç 300, Standart 1.500, Pro 10.000 üye. Kurumsal planda sınır yoktur. Sınıra yaklaştığınızda panel uyarır; veri hiçbir zaman silinmez.',
      },
      {
        soru: 'Eski programımızdaki üye numaraları korunur mu?',
        cevap:
          'Evet. İçe aktarımda mevcut üye numaranız ayrı bir alanda saklanır; yeni numara vermek zorunda değilsiniz.',
      },
      {
        soru: 'Bu liste yasal üye kayıt defteri sayılır mı?',
        cevap:
          'Hayır. Dernekler Yönetmeliği elektronik defteri Bakanlıkça izin verilen yazılımlara bağlar; bu izin için başvuru sürecindeyiz. O güne kadar liste, defteri tutmanıza yardım eden operasyonel bir kopyadır ve bunu ekranda açıkça yazarız.',
      },
    ],
    iliskili: ['aidat-ve-tahsilat', 'kurullar-ve-genel-kurul', 'uye-portali-ve-mobil'],
  },
  {
    slug: 'aidat-ve-tahsilat',
    ad: 'Aidat ve tahsilat',
    kisa: 'Tarife tanımlayın; borçlandırma, hatırlatma ve tahsilat kendiliğinden işlesin.',
    aciklama:
      'Aidat, üyelik tipi başına tarifeyle tanımlanır ve dönem başında borç kendiliğinden oluşur. Üye kartla, havaleyle ya da portaldan öder; ödeme kayda düştüğü anda borç kapanır ve makbuz kesilir.',
    ikon: Wallet,
    grup: 'cekirdek',
    durum: 'hazir',
    faz: 'Faz 1',
    ozellikler: [
      {
        baslik: 'Tarifeler ve zam',
        aciklama:
          'Zam için yeni tarife eklenir; eskisi geçmiş borçların dayanağı olarak kalır. Geçmişe dönük tutar değişmez.',
      },
      {
        baslik: 'Otomatik borçlandırma',
        aciklama:
          'Yıllık ya da aylık dönemde borç kendiliğinden oluşur. Üyelik ortasında başlayanlara kıst hesabı uygulanabilir.',
      },
      {
        baslik: 'Online tahsilat',
        aciklama:
          'PayTR, İyzico, Kuveyt Türk ve Param ile kartla ödeme. Anahtarlar sizin hesabınıza aittir; para doğrudan derneğin hesabına geçer.',
      },
      {
        baslik: 'Havale eşleştirme',
        aciklama:
          'Üyeye sipariş numaralı açıklama gösterilir; gelen havale açıklamadan eşleşir. Eşleşmeyen dekont görevliye düşer.',
      },
      {
        baslik: 'Hatırlatma dizileri',
        aciklama:
          'Vade öncesi, vade günü ve gecikme hatırlatmaları e-posta ve SMS ile. Ödeyen üyeye ikinci hatırlatma gitmez.',
      },
      {
        baslik: 'Makbuz',
        aciklama:
          'Her tahsilat için derneğin makbuzu PDF olarak üretilir ve üyeye gider. Resmî alındı belgesi DERBİS üzerinden düzenlenir; makbuzda referansı saklanır.',
      },
      {
        baslik: 'Borç ve ekstre',
        aciklama:
          'Üye bazında borç, ödeme ve iade dökümü. Yönetim kuruluna dönem sonu tahsilat raporu tek tıkla.',
      },
      {
        baslik: 'Kuruş hassasiyeti',
        aciklama:
          'Para her yerde kuruş cinsinden tam sayı tutulur; yuvarlama farkı oluşmaz. Fiyatlama çekirdeği yüzde yüz test kapsamındadır.',
      },
      {
        baslik: 'Borcu yoktur yazısı',
        aciklama:
          'Üye portaldan kendi "borcu yoktur" belgesini indirir; belge numarası doğrulanabilir. Gecikme tazminatı tarifeye bağlanabilir.',
      },
    ],
    senaryo: {
      baslik: 'Ocak ayında ne olur',
      metin: [
        'Dönem başında her aktif üyeye tarifesine göre borç oluşur. Sayman hiçbir şey yapmaz; ekranda bekleyen tahsilat toplamını görür.',
        'Üyelere vade hatırlatması gider. Üye e-postadaki bağlantıdan portala girer, kartıyla öder; makbuz aynı dakika e-postasındadır.',
        'Havaleyle ödeyen üyenin dekontu açıklamadaki numarayla eşleşir. Ay sonunda sayman gecikenlere ikinci hatırlatmayı tek tıkla gönderir.',
      ],
    },
    mockup: 'aidat',
    sss: [
      {
        soru: 'Tahsilat üzerinden komisyon alıyor musunuz?',
        cevap:
          'Hayır. Ödeme sağlayıcısının kendi komisyonu dışında bizim payımız yoktur. Sağlayıcı sözleşmesi sizinle sağlayıcı arasındadır.',
      },
      {
        soru: 'Sanal POS başvurusunu siz mi yapıyorsunuz?',
        cevap:
          'Başvuruyu dernek yapar; hangi belgelerin gerektiğini ve nasıl ilerleyeceğinizi adım adım anlatan rehberimiz vardır. Anahtarlar geldiğinde panelden girersiniz.',
      },
      {
        soru: 'Kısmi ödeme ve taksit mümkün mü?',
        cevap:
          'Kısmi ödeme kabul edilir ve borç kalan tutarla açık kalır. Kart taksiti sağlayıcınızın tanımına bağlıdır.',
      },
    ],
    iliskili: ['uye-yonetimi', 'muhasebe-ve-raporlar', 'uye-portali-ve-mobil'],
  },
  {
    slug: 'web-sitesi',
    ad: 'Web sitesi ve içerik',
    kisa: 'Derneğinize ait, kendi alan adında yayınlanan hazır web sitesi.',
    aciklama:
      'Dernek açıldığı anda web siteniz de açılır. Haber, duyuru, sayfa, belge ve galeri panelden yönetilir; şablon ve renkler sizin, sertifika ve barındırma bizim işimiz.',
    ikon: Globe,
    grup: 'cekirdek',
    durum: 'gelistiriliyor',
    faz: 'Faz 1',
    ozellikler: [
      {
        baslik: 'Hazır şablonlar',
        aciklama:
          'Kurumsal, meslek örgütü ve topluluk şablonları. Logo, renk ve yazı tipi tema düzenleyiciden değişir; kod gerekmez.',
      },
      {
        baslik: 'Blok tabanlı sayfalar',
        aciklama:
          'Metin, görsel, yönetim kurulu, belge listesi, etkinlik takvimi gibi bloklarla sayfa kurarsınız. Sürükleyip sıralarsınız.',
      },
      {
        baslik: 'Haber, duyuru, belge, galeri',
        aciklama:
          'Tüzük, faaliyet raporu ve genel kurul ilanı belge olarak; etkinlik fotoğrafları galeri olarak yayınlanır.',
      },
      {
        baslik: 'Kendi alan adınız',
        aciklama:
          'dernekadi.org.tr sizin kalır. Bir TXT kaydıyla doğrularız, sertifikayı biz alır ve yeniler; site saniyeler içinde yayındadır.',
      },
      {
        baslik: 'Hızlı ve erişilebilir',
        aciklama:
          'Sayfalar sunucuda üretilir; ziyaretçiye ağır betik inmez. Başlık yapısı ve alternatif metinler erişilebilirlik kurallarına göre çıkar.',
      },
      {
        baslik: 'Üyelik başvurusu ve ödeme sayfaları',
        aciklama:
          'Başvuru formu, aidat ödeme ve etkinlik kaydı sitede hazırdır ve doğrudan panelinize düşer.',
      },
      {
        baslik: 'Arama motoru için hazır',
        aciklama:
          'Site haritası, meta etiketleri ve paylaşım görselleri kendiliğinden üretilir. Her sayfanın adresi okunaklıdır.',
      },
    ],
    senaryo: {
      baslik: 'Genel kurul ilanı üç dakikada',
      metin: [
        'Sekreter panelde "duyuru" açar, ilan metnini yapıştırır, gündemi ekler, tarihi seçer.',
        'Yayınladığı anda site ana sayfasında, üye portalında ve isterse üyelere e-posta olarak gider.',
        'İlan metni belge olarak da eklenir; denetimde "ne zaman yayınlandı" sorusunun cevabı denetim kaydındadır.',
      ],
    },
    mockup: 'web-sitesi',
    sss: [
      {
        soru: 'Mevcut sitemizi taşıyabilir miyiz?',
        cevap:
          'Sayfa ve haber içeriğinizi içe aktarma aracıyla ya da geçiş ekibimizle taşırız. Tasarım birebir kopyalanmaz; şablonlardan biri sizin markanıza uyarlanır.',
      },
      {
        soru: 'Alan adını siz mi alıyorsunuz?',
        cevap:
          'Alan adı derneğin adına kalır; siz alır ya da mevcut kaydınızı kullanırsınız. Biz yalnızca yönlendirme ve sertifikayı yönetiriz.',
      },
      {
        soru: 'Özel alan adı hangi planlarda var?',
        cevap:
          'Standart ve üzeri planlarda. Başlangıç planında siteniz dernekadi.akillidernek.com adresinde yayınlanır.',
      },
    ],
    iliskili: ['iletisim', 'uye-portali-ve-mobil', 'etkinlik-ve-kongre'],
  },
  {
    slug: 'iletisim',
    ad: 'E-posta ve SMS',
    kisa: 'Duyuru ve hatırlatmaları doğru üyeye, doğru kanaldan, ölçerek gönderin.',
    aciklama:
      'Toplu e-posta bizim altyapımızdan, SMS kendi Netgsm hesabınızdan gider. Kime ulaştı, kim açtı, kim geri döndü görürsünüz; hatırlatmalar aidat ve etkinlik modülleriyle bağlıdır.',
    ikon: Megaphone,
    grup: 'cekirdek',
    durum: 'gelistiriliyor',
    faz: 'Faz 1',
    ozellikler: [
      {
        baslik: 'Kampanya gönderimi',
        aciklama:
          'Hedef kitleyi üye durumu, tip, borç durumu ve etiketle seçersiniz. Gönderim öncesi kaç kişiye gideceği görünür.',
      },
      {
        baslik: 'Şablonlar',
        aciklama:
          'Hoş geldiniz, aidat hatırlatma, etkinlik daveti hazır şablonlarla gelir. Dernek adı, üye adı ve tutar alanları kendiliğinden dolar.',
      },
      {
        baslik: 'Teslimat raporu',
        aciklama:
          'İletilen, açılan, tıklanan, geri dönen. Geçersiz adresler işaretlenir; bir sonraki gönderimde tekrar denenmez.',
      },
      {
        baslik: 'SMS kendi hesabınızdan',
        aciklama:
          'Netgsm anahtarınızı ve başlığınızı panelden girersiniz; kontör sizin hesabınızda kalır. Ticari ileti sorumluluğu derneğinizde, olması gerektiği yerde.',
      },
      {
        baslik: 'Kendi alan adınızdan e-posta',
        aciklama:
          'Gönderen adresi dernek@dernekadi.org.tr olur. Alan adı doğrulaması panelden, adım adım.',
      },
      {
        baslik: 'Uygulama içi ve anlık bildirim',
        aciklama:
          'Üye portalı ve mobil uygulamada bildirim merkezi. Acil duyurular anlık bildirim olarak gider.',
      },
      {
        baslik: 'Kota ve adil kullanım',
        aciklama:
          'Plan başına aylık e-posta kotası; dolunca gönderim durur, sessizce kırpılmaz. Kota bir sonraki ay sıfırlanır.',
      },
      {
        baslik: 'WhatsApp bildirimi',
        aciklama:
          'Onaylı WhatsApp işletme hesabınızdan aidat hatırlatması ve etkinlik bilgisi. Üye yanıtları destek talebine dönüşür.',
      },
      {
        baslik: 'Anket',
        aciklama:
          'Üyelere kısa anket; sonuçlar üye tipine göre kırılımlı. Genel kurul öncesi nabız yoklaması için.',
      },
    ],
    senaryo: {
      baslik: 'Kongre daveti: kim geldi, kim gelmedi',
      metin: [
        'Etkinlik açıldığında davet kampanyası hazır şablonla oluşur. Hedef: aktif üyeler, borcu olmayanlar önce.',
        'Gönderimden sonra rapor: yüzde kaçı açtı, kaçı kayıt sayfasına tıkladı. Açmayanlara üç gün sonra SMS hatırlatması.',
        'Kayıt olanlar listeden düşer; ikinci dalga yalnızca kayıt olmayanlara gider.',
      ],
    },
    mockup: 'iletisim',
    sss: [
      {
        soru: 'SMS paketi satıyor musunuz?',
        cevap:
          'Hayır. Derneğiniz kendi Netgsm hesabını bağlar. Böylece ileti onayı ve sorumluluk derneğinizde kalır; biz araya girmeyiz.',
      },
      {
        soru: 'E-posta gönderimi için ek ücret var mı?',
        cevap:
          'Plan kotası dahilinde yoktur. Kota aşımı gerekiyorsa üst plana geçilir ya da görüşülür.',
      },
      {
        soru: 'Üye e-posta almak istemezse?',
        cevap:
          'Her e-postanın altında çıkış bağlantısı vardır; işlem postaları (makbuz, şifre) bunun dışındadır. Tercih üye kaydında saklanır.',
      },
    ],
    iliskili: ['aidat-ve-tahsilat', 'etkinlik-ve-kongre', 'uye-portali-ve-mobil'],
  },
  {
    slug: 'uye-portali-ve-mobil',
    ad: 'Üye portalı ve mobil uygulama',
    kisa: 'Üyeleriniz kendi bilgisini görür, aidatını öder, kartını taşır.',
    aciklama:
      'Her derneğin kendi alt alan adında üye portalı vardır. Üye başvurur, üyelik durumunu ve borcunu görür, öder, destek ister. Mobil uygulama aynı hesaba dijital üye kartı ve etkinlik girişi ekler.',
    ikon: Smartphone,
    grup: 'cekirdek',
    durum: 'gelistiriliyor',
    faz: 'Faz 1 · Mobil Faz 2',
    ozellikler: [
      {
        baslik: 'Kendi adresinizde portal',
        aciklama:
          'dernekadi.akillidernek.com ya da kendi alan adınız. Üye oturumu yöneticininkinden ayrıdır; birbirini düşürmez.',
      },
      {
        baslik: 'Üyelik başvurusu',
        aciklama:
          'Kaydı olmayan kişi başvuru formunu doldurur; başvuru panelde onay bekler. Belgeler eklenebilir.',
      },
      {
        baslik: 'Borç görme ve ödeme',
        aciklama:
          'Açık borçlar, geçmiş ödemeler ve makbuzlar. Kartla ödeme portaldan, havale bilgileri sipariş numarasıyla.',
      },
      {
        baslik: 'Destek talepleri',
        aciklama:
          'Üye derneğe sorusunu iletir, yanıtı takip eder. Dernek görevlisi panelden yanıtlar; yazışma tek yerde kalır.',
      },
      {
        baslik: 'Dijital üye kartı',
        aciklama:
          'Mobil uygulamada QR kodlu üye kartı. Etkinlik girişinde ve anlaşmalı kurumlarda okutulur.',
      },
      {
        baslik: 'Yönetici modu',
        aciklama:
          'Aynı uygulamada yönetici için özet, bekleyen onaylar ve kapı QR okuyucu. Kongre girişinde ayrı cihaz gerekmez.',
      },
      {
        baslik: 'Profil ve tercihler',
        aciklama:
          'Üye iletişim bilgisini kendisi günceller; değişiklik panele düşer. Bildirim tercihleri üyenin elindedir.',
      },
    ],
    senaryo: {
      baslik: 'Üye borcunu kendi öğrenir',
      metin: [
        'Üye "aidat borcum var mı" diye derneği aramak yerine portala girer. Ekranda açık borç, vade ve ödeme seçenekleri.',
        'Kartla öder; makbuz hem ekranda hem e-postada. Sayman sabah panelde tahsilatı görür, elle hiçbir şey girmez.',
        'Kongre günü üye telefonundaki kartı okutur; kapıda liste, imza ve yaka kartı arama yoktur.',
      ],
    },
    mockup: 'portal',
    sss: [
      {
        soru: 'Mobil uygulama mağazada derneğimizin adıyla mı çıkar?',
        cevap:
          'Tek bir Akıllı Dernek uygulaması vardır; üye giriş yapınca bağlı olduğu dernekleri görür. Derneğe özel mağaza uygulaması Kurumsal planda görüşülür.',
      },
      {
        soru: 'Portal her planda var mı?',
        cevap: 'Evet, üye portalı çekirdek özelliktir ve bütün planlarda açıktır.',
      },
      {
        soru: 'Üyeler şifreyi nasıl alır?',
        cevap:
          'Panelden davet gönderilir ya da üye e-postasıyla kendisi kayıt olur; dernek kaydıyla eşleşir. Şifreyi üye belirler, görevli görmez.',
      },
    ],
    iliskili: ['aidat-ve-tahsilat', 'etkinlik-ve-kongre', 'iletisim'],
  },
  {
    slug: 'kurullar-ve-genel-kurul',
    ad: 'Kurullar ve genel kurul',
    kisa: 'Kurul, toplantı ve karar defteri; online genel kurul ve elektronik oylama.',
    aciklama:
      'Genel kurulun seçtiği yönetim ve denetim kurulunu dönemleriyle kaydedersiniz. Toplantılar açılır, kararlar sıra numarasıyla altına yazılır. Genel kurul için hazirun listesi, çağrı, canlı oturum ve oylama aynı yerdedir.',
    ikon: Landmark,
    grup: 'cekirdek',
    durum: 'gelistiriliyor',
    faz: 'Faz 1 · Online genel kurul Faz 3',
    ozellikler: [
      {
        baslik: 'Kurullar ve dönemler',
        aciklama:
          'Yönetim, denetim, disiplin ve komisyonlar. Dönem başlangıcı seçim tarihidir; yalnızca aktif üyeler görev alabilir.',
      },
      {
        baslik: 'Toplantı ve karar defteri',
        aciklama:
          'Toplantı sırası ve karar numarası kendiliğinden verilir ve geri alınmaz. Kararlar PDF olarak dışa aktarılır.',
      },
      {
        baslik: 'Genel kurul çağrısı',
        aciklama:
          'Gündem, tarih ve yer bilgisiyle çağrı metni; yönetmelikteki süre şartı takvimde hatırlatılır. Site ve e-postayla ilan.',
      },
      {
        baslik: 'Hazirun listesi',
        aciklama:
          'Oy hakkı olan üyeler aidat durumuna göre otomatik listelenir. Girişte QR ile yoklama; imza listesi PDF.',
      },
      {
        baslik: 'Online genel kurul',
        aciklama:
          'Yüzlerce üyenin katıldığı canlı oturum, kayıt altına alınır. Kayıt tutanağın dayanağı olarak saklanır.',
      },
      {
        baslik: 'Elektronik oylama',
        aciklama:
          'Açık ve gizli oylama; oy hakkı hazirun listesinden gelir. Sonuç anında, oy kaydı değiştirilemez.',
      },
      {
        baslik: 'Tutanak ve bildirim',
        aciklama:
          'Genel kurul sonuç bildirimi için gereken bilgiler tek dökümde. Seçilen kurul aynı ekrandan yeni dönem olarak açılır.',
      },
    ],
    senaryo: {
      baslik: 'Genel kurul günü',
      metin: [
        'Çağrı on beş gün önce siteden ve e-postayla yapılmıştır; sistem süreyi takvime işlemiştir. Hazirun listesi aidat borcu olmayan üyelerden otomatik çıkmıştır.',
        'Kapıda üyeler QR ile yoklama verir; çoğunluk sağlandığı anda ekranda görünür. Uzaktan katılanlar canlı oturuma bağlanır.',
        'Divan oylamayı açar; salondakiler ve uzaktakiler aynı anda oy verir. Sonuç tutanağa işlenir, yeni yönetim kurulu dönemi açılır.',
      ],
    },
    mockup: 'kurullar',
    sss: [
      {
        soru: 'Online genel kurul hukuken geçerli mi?',
        cevap:
          'Dernekler Yönetmeliği elektronik ortamda genel kurula, tüzükte hüküm bulunması şartıyla izin verir. Tüzük düzenlemesi için örnek madde metnini paylaşırız; hukuki değerlendirme derneğin danışmanına aittir.',
      },
      {
        soru: 'Karar defterini elle tutmaya devam etmemiz gerekir mi?',
        cevap:
          'Noter tasdikli defter yükümlülüğü devam eder. Sistemdeki kayıt, defteri düzenli ve hatasız yazmanızı kolaylaştıran çalışma kopyasıdır.',
      },
      {
        soru: 'Oylama gizliliği nasıl sağlanır?',
        cevap:
          'Gizli oylamada oy ile üye bağı kapatılarak saklanır; yalnızca "oy kullandı" bilgisi kalır. Sonuçlar denetim kaydıyla birlikte tutulur.',
      },
    ],
    iliskili: ['uye-yonetimi', 'iletisim', 'guvenlik-ve-kvkk'],
  },
  {
    slug: 'muhasebe-ve-raporlar',
    ad: 'Gelir-gider ve raporlar',
    kisa: 'Kasa, banka, bütçe ve yönetim kuruluna hazır raporlar.',
    aciklama:
      'Aidat ve etkinlik tahsilatı kendiliğinden gelir kalemine düşer; giderleri belgesiyle girersiniz. Kasa ve banka hesapları, bütçe karşılaştırması ve dönem raporu yönetim kurulu ve denetim kurulu için hazırdır. Mali müşavirinize dışa aktarım tek tıkla.',
    ikon: BookOpenCheck,
    grup: 'cekirdek',
    durum: 'planlandi',
    faz: 'Faz 2',
    ozellikler: [
      {
        baslik: 'Gelir ve gider kalemleri',
        aciklama:
          'Aidat, bağış, etkinlik, satış gelirleri kendiliğinden; kira, personel, organizasyon giderleri belgesiyle. Kalem ağacı sizin.',
      },
      {
        baslik: 'Kasa ve banka',
        aciklama:
          'Birden çok hesap, hesaplar arası virman, banka ekstresi içe aktarımı ve eşleştirme.',
      },
      {
        baslik: 'Banka hareketi eşleştirme',
        aciklama:
          'Bankanızın hesap hareketleri günlük çekilir; aidat ve bağış ödemeleri açıklamadan üyeyle eşleşir, kalanlar görevliye düşer.',
      },
      {
        baslik: 'Bütçe',
        aciklama:
          'Genel kurulda onaylanan bütçe kalem bazında girilir; gerçekleşenle fark ay ay izlenir.',
      },
      {
        baslik: 'Dönem raporları',
        aciklama:
          'Gelir-gider tablosu, tahsilat özeti, borçlu üyeler, etkinlik kârlılığı. Denetim kurulu raporu için hazır döküm.',
      },
      {
        baslik: 'Mali müşavir dışa aktarımı',
        aciklama:
          'İşletme defteri düzeninde Excel ve muhasebe programlarına uygun biçim. Paraşüt bağlantısı Kurumsal planda.',
      },
      {
        baslik: 'Belge arşivi',
        aciklama:
          'Fatura, dekont ve makbuz görselleri kaleme iliştirilir; denetimde kalemden belgeye tek tıkla.',
      },
      {
        baslik: 'Resmî belge referansları',
        aciklama:
          'DERBİS üzerinden düzenlenen alındı belgesinin numarası ve tarihi tahsilata iliştirilir; beyanname hazırlığında liste hazırdır.',
      },
      {
        baslik: 'Beyanname hazırlığı',
        aciklama:
          'İşletme hesabı tablosu (Ek-16) düzeninde döküm ve yıllık beyanname (Ek-21) için gereken toplamlar hazır. DERBİS’e girişi dernek yapar.',
      },
      {
        baslik: 'Denetim kurulu görünümü',
        aciklama:
          'Denetim kurulu üyeleri salt okunur rolle bütün mali kayda ve belgeye ulaşır; değiştiremez, ama her şeyi görür.',
      },
    ],
    senaryo: {
      baslik: 'Denetim kurulu toplantısı',
      metin: [
        'Denetim kurulu üyesi salt okunur rolle panele girer. Dönem gelir-gider tablosu ve kalemden belgeye bağlantılar önünde.',
        'Bir gider kalemini açar, faturayı görür, kim ne zaman girmiş denetim kaydından okur.',
        'Raporu PDF olarak indirir; imzalı nüsha belge arşivine yüklenir.',
      ],
    },
    mockup: 'muhasebe',
    sss: [
      {
        soru: 'Bu resmî defter yerine geçer mi?',
        cevap:
          'Hayır. Defter yükümlülüğü mevzuata göre devam eder; sistem defteri tutmanız için düzenli ve belgeli veri üretir. Mali müşaviriniz dışa aktarımı doğrudan kullanabilir.',
      },
      {
        soru: 'Mali müşavirime erişim verebilir miyim?',
        cevap:
          'Evet. "Mali müşavir" hazır rolü yalnızca finans ekranlarını görür; üye kişisel verisine erişmez.',
      },
      {
        soru: 'Bu modül ne zaman hazır olacak?',
        cevap:
          'Yol haritasında Faz 2. Aidat tahsilatı ve makbuz bugün çalışıyor; gider ve bütçe tarafı bunun üstüne geliyor.',
      },
    ],
    iliskili: ['aidat-ve-tahsilat', 'bagis-ve-kampanya', 'guvenlik-ve-kvkk'],
  },
  {
    slug: 'bagis-ve-kampanya',
    ad: 'Bağış, burs ve gönüllü',
    kisa: 'Bağış sayfası, düzenli bağış, kampanya hedefi, burs ve gönüllü takibi.',
    aciklama:
      'Sitenizde ve portalda bağış sayfası hazırdır. Tek seferlik ya da aylık düzenli bağış alınır, kampanya hedefi canlı izlenir, bağışçıya makbuz gider. Bağış geliri kendiliğinden gelir kalemine düşer.',
    ikon: HandCoins,
    grup: 'cekirdek',
    durum: 'planlandi',
    faz: 'Faz 2',
    ozellikler: [
      {
        baslik: 'Bağış sayfası',
        aciklama:
          'Hazır tutarlar, serbest tutar, isteğe bağlı isim gizleme. Kartla ödeme mevcut sağlayıcınızla.',
      },
      {
        baslik: 'Düzenli bağış',
        aciklama:
          'Aylık talimat; kart bilgisi sağlayıcıda saklanır, bizde tutulmaz. Bağışçı istediği an durdurur.',
      },
      {
        baslik: 'Kampanya ve hedef',
        aciklama:
          'Burs fonu, yardım kampanyası, bina onarımı: hedef tutar, süre ve canlı ilerleme çubuğu.',
      },
      {
        baslik: 'Bağışçı kaydı ve makbuz',
        aciklama:
          'Bağışçı üye olmak zorunda değildir. Makbuz e-postayla gider; yıl sonu bağış dökümü tek tıkla.',
      },
      {
        baslik: 'Burs ve yardım takibi',
        aciklama:
          'Toplanan fonun kime, ne zaman, ne kadar verildiği. Bursiyer dosyası ve ödeme planı.',
      },
      {
        baslik: 'Kurumsal bağışçılar ve sponsorlar',
        aciklama:
          'Şirket bağışları sözleşme ve fatura bilgisiyle; sponsorlar etkinlik modülüyle bağlı.',
      },
      {
        baslik: 'Gönüllü ve görev takibi',
        aciklama:
          'Gönüllü havuzu, görev listesi ve saat kaydı. Etkinlik günü kimin nerede olduğu tek ekranda; gönüllü belgesi PDF.',
      },
    ],
    senaryo: {
      baslik: 'Burs kampanyası',
      metin: [
        'Dernek "50 öğrenciye burs" kampanyasını açar; hedef ve süre girilir, sayfa siteye düşer.',
        'Üyelere ve geçmiş bağışçılara e-posta gider. Sayfadaki ilerleme çubuğu her bağışta ilerler.',
        'Kampanya bitince fon burs modülüne aktarılır; bursiyerlere aylık ödeme planı kurulur ve gider olarak işlenir.',
      ],
    },
    mockup: 'bagis',
    sss: [
      {
        soru: 'Bağıştan komisyon alınır mı?',
        cevap: 'Bizim tarafımızdan alınmaz. Sağlayıcı komisyonu sağlayıcı sözleşmenize bağlıdır.',
      },
      {
        soru: 'Yardım toplama izni gerekir mi?',
        cevap:
          'Kamuya açık yardım toplama faaliyeti mevzuatta izne bağlıdır; üyelerden ve belirli kişilerden bağış kabulü farklıdır. Kampanya açarken bu ayrımı ekranda hatırlatırız; karar ve başvuru derneğe aittir.',
      },
    ],
    iliskili: ['muhasebe-ve-raporlar', 'web-sitesi', 'iletisim'],
  },
  {
    slug: 'etkinlik-ve-kongre',
    ad: 'Etkinlik ve kongre',
    kisa: 'Biletten konaklamaya, kapı kontrolünden sertifikaya bütün kongre.',
    aciklama:
      'Küçük bir seminerden bin kişilik kongreye aynı motor. Bilet tipleri ve erken kayıt dönemleri, konaklama ve oda arkadaşı eşleştirme, transfer, gala, program, konuşmacılar, QR ile kapı kontrolü, sponsor ve stant yönetimi, katılım sertifikası.',
    ikon: CalendarDays,
    grup: 'paket',
    durum: 'planlandi',
    faz: 'Faz 2',
    paketFiyati: 1490,
    ozellikler: [
      {
        baslik: 'Bilet tipleri ve dönemler',
        aciklama:
          'Üye, üye olmayan, öğrenci, refakatçi. Erken kayıt, normal ve geç dönem fiyatları tarihle kendiliğinden değişir.',
      },
      {
        baslik: 'Konaklama ve oda arkadaşı',
        aciklama:
          'Otel, oda tipi ve gece sayısı kayıtla birlikte satılır. Tek kişilik istemeyenler oda arkadaşı tercihiyle eşleşir.',
      },
      {
        baslik: 'Transfer ve gala',
        aciklama:
          'Havalimanı transferi saat dilimleriyle; gala yemeği ayrı kalem. Hepsi tek siparişte, tek ödemede.',
      },
      {
        baslik: 'Program ve konuşmacılar',
        aciklama:
          'Paralel salonlar, oturumlar, konuşmacı profilleri. Program sitede ve uygulamada; değişiklik anında yansır.',
      },
      {
        baslik: 'QR kapı kontrolü',
        aciklama:
          'Katılımcı QR kodunu telefonundan gösterir; görevli mobil uygulamayla okutur. Mükerrer giriş ve yanlış salon uyarısı.',
      },
      {
        baslik: 'Sponsor ve stant',
        aciklama:
          'Sponsor paketleri, stant planı ve sponsor logolarının site ve program kitapçığında yeri. Sponsor faturası kayıtla bağlı.',
      },
      {
        baslik: 'Yaka kartı ve sertifika',
        aciklama:
          'Yaka kartı toplu ya da kapıda basılır. Katılım sertifikası oturum yoklamasına göre PDF olarak gider.',
      },
      {
        baslik: 'Bildiri ve hakem süreci',
        aciklama:
          'Özet gönderimi, hakem ataması, kabul ve poster/sözlü ayrımı. Bilimsel kongrelerin ihtiyacına göre.',
      },
      {
        baslik: 'Anket ve geri bildirim',
        aciklama: 'Oturum sonu ve kongre sonu anketi; sonuçlar konuşmacı bazında raporlanır.',
      },
    ],
    senaryo: {
      baslik: 'Bin kişilik kongre, üç kişilik ekip',
      metin: [
        'Kayıt sayfası açılır: bilet, otel, transfer ve gala tek sepette. Erken kayıt bitince fiyat gece yarısı kendiliğinden değişir.',
        'Otel listesi haftalık olarak otele gider; oda arkadaşı eşleşmeleri sistemden çıkar. Sponsor logoları siteye ve program kitapçığına aynı anda düşer.',
        'Kongre sabahı kapıda üç görevli, üç telefon. Kuyruk yok; kim hangi salonda anlık görünür. Kapanışta sertifikalar yoklamaya göre otomatik gider.',
      ],
    },
    mockup: 'kongre',
    sss: [
      {
        soru: 'Etkinlik başına ücret var mı?',
        cevap:
          'Hayır. Etkinlik paketi aylıktır; kaç etkinlik açtığınız ve kaç bilet sattığınız fark etmez. Bilet başına komisyon yoktur.',
      },
      {
        soru: 'Üye olmayanlar kayıt olabilir mi?',
        cevap:
          'Evet. Katılımcı kaydı üyelikten bağımsızdır; isterse kayıt sırasında üyelik başvurusu da yapar.',
      },
      {
        soru: 'Kapı kontrolü internet gerektirir mi?',
        cevap:
          'Okuyucu uygulama katılımcı listesini önceden indirir; bağlantı kesilse de okutma devam eder, bağlanınca eşitlenir.',
      },
    ],
    iliskili: ['uye-portali-ve-mobil', 'iletisim', 'akademi'],
  },
  {
    slug: 'akademi',
    ad: 'Akademi ve webinar',
    kisa: 'Kurs, canlı ders, sınav ve sertifika; hepsi üyelik hesabıyla.',
    aciklama:
      'Derneğinizin eğitimleri kendi akademinizde. Video dersler, canlı webinar, sınav ve sertifika; üyeye özel fiyat ve kupon. Canlı ders kaydı otomatik olarak ders arşivine düşer.',
    ikon: GraduationCap,
    grup: 'paket',
    durum: 'planlandi',
    faz: 'Faz 3',
    paketFiyati: 1490,
    ozellikler: [
      {
        baslik: 'Kurs ve ders yapısı',
        aciklama:
          'Modül, ders, video ve belge. İzleme ilerlemesi üye bazında saklanır; kaldığı yerden devam eder.',
      },
      {
        baslik: 'Canlı webinar',
        aciklama:
          'Yerleşik canlı yayın; katılımcı sınırı plana göre. Kayıt bitince ders olarak yayınlanır.',
      },
      {
        baslik: 'Zoom ile çalışma',
        aciklama: 'Zoom hesabınız varsa ders Zoom’da yapılır, kayıt ve yoklama platforma düşer.',
      },
      {
        baslik: 'Sınav ve sertifika',
        aciklama:
          'Çoktan seçmeli sınav, geçme notu, sertifika şablonu. Sertifika doğrulama adresi ve numarasıyla.',
      },
      {
        baslik: 'Kohort ve takvim',
        aciklama: 'Dönemli eğitimler için kohort; başlangıç, bitiş ve ödevler takvimde.',
      },
      {
        baslik: 'Fiyat, kupon, üye indirimi',
        aciklama:
          'Üye ve üye olmayan fiyatı, kupon kodları, kurumsal toplu kayıt. Satış tek sipariş çekirdeğinden.',
      },
      {
        baslik: 'Eğitmen ekranı',
        aciklama:
          'Eğitmen kendi kurslarını, katılımcı listesini ve sınav sonuçlarını görür; başka veriye erişmez.',
      },
    ],
    senaryo: {
      baslik: 'Sertifika programı',
      metin: [
        'Dernek sekiz haftalık program açar: dört canlı ders, dört video modül, bitirme sınavı.',
        'Üyeler indirimli kayıt olur; canlı dersler kaydedilip ertesi gün arşive düşer, kaçıran izler.',
        'Sınavı geçenlere numaralı sertifika gider; işveren doğrulama adresinden kontrol eder.',
      ],
    },
    mockup: 'akademi',
    sss: [
      {
        soru: 'Video depolama sınırı var mı?',
        cevap: 'Plan depolama kotasına dahildir. Uzun arşivler için ek depolama görüşülür.',
      },
      {
        soru: 'Kendi eğitmenlerimiz için ayrı hesap gerekir mi?',
        cevap: 'Eğitmen hazır rolüyle davet edilir; yalnızca kendi kurslarını görür.',
      },
    ],
    iliskili: ['etkinlik-ve-kongre', 'uye-portali-ve-mobil', 'iletisim'],
  },
  {
    slug: 'magaza',
    ad: 'Mağaza ve stok',
    kisa: 'Yayın, rozet, kitap: derneğin ürünleri kendi mağazasında.',
    aciklama:
      'Derneğinizin yayınlarını, ürünlerini ve hizmetlerini kendi mağazanızda satarsınız. Katalog, varyant, üye fiyatı, stok ve kargo; sipariş ödeme çekirdeğine, gelir raporlara düşer.',
    ikon: ShoppingBag,
    grup: 'paket',
    durum: 'planlandi',
    faz: 'Faz 4',
    paketFiyati: 1990,
    ozellikler: [
      {
        baslik: 'Katalog ve varyant',
        aciklama: 'Beden, renk, baskı gibi varyantlar; üye ve üye olmayan fiyat listeleri.',
      },
      {
        baslik: 'Stok ve depo',
        aciklama: 'Raf, sayım, toplama listesi. Stok düşünce uyarı; sayım farkı kaydı.',
      },
      {
        baslik: 'Kargo',
        aciklama: 'Kargo etiketi ve takip numarası tek ekrandan; müşteriye takip bağlantısı gider.',
      },
      {
        baslik: 'Kampanya ve kupon',
        aciklama: 'Dönemsel indirim, üye kuponu, toplu alım fiyatı.',
      },
      {
        baslik: 'İade',
        aciklama: 'İade talebi, onay ve para iadesi sağlayıcı üzerinden; stok geri işlenir.',
      },
      {
        baslik: 'Fatura bilgisi',
        aciklama:
          'Kurumsal alıcı için fatura bilgileri siparişte; mali müşavir dışa aktarımında hazır.',
      },
    ],
    senaryo: {
      baslik: 'Yeni yayın çıktı',
      metin: [
        'Kitap kataloğa eklenir; üye fiyatı otomatik uygulanır. Duyuru e-postası mağaza bağlantısıyla gider.',
        'Siparişler toplama listesine düşer; kargo etiketi basılır, takip numarası alıcıya gider.',
        'Stok azalınca uyarı; satış geliri raporda yayın kalemine işlenir.',
      ],
    },
    mockup: 'magaza',
    sss: [
      {
        soru: 'Pazaryeri entegrasyonu var mı?',
        cevap: 'Yol haritasında değil. Mağaza derneğin kendi sitesinde çalışır.',
      },
    ],
    iliskili: ['muhasebe-ve-raporlar', 'web-sitesi', 'aidat-ve-tahsilat'],
  },
  {
    slug: 'guvenlik-ve-kvkk',
    ad: 'Güvenlik ve KVKK',
    kisa: 'Veriniz sizin; izolasyon veritabanında, erişim rolle, her işlem kayıtta.',
    aciklama:
      'Her derneğin verisi veritabanı seviyesinde ayrılır; bir derneğin kullanıcısı başka derneğin satırını göremez. Roller ince taneli, ikinci adım doğrulama zorunlu kılınabilir, her değişiklik kim-ne zaman bilgisiyle saklanır. Kişisel veri saklama süreleri KVKK ilkelerine göre işler.',
    ikon: ShieldCheck,
    grup: 'ust',
    durum: 'hazir',
    faz: 'Faz 0',
    ozellikler: [
      {
        baslik: 'Veritabanı seviyesinde izolasyon',
        aciklama:
          'Kiracı ayrımı uygulama kodundaki filtreye değil, Postgres satır seviyesi güvenliğe dayanır. Unutulan bir filtre veri sızdıramaz.',
      },
      {
        baslik: 'Roller ve izinler',
        aciklama:
          'Başkan, sekreter, sayman, denetim kurulu, mali müşavir hazır rolleri; izinler modül ve eylem bazında kısılır.',
      },
      {
        baslik: 'İkinci adım doğrulama',
        aciklama:
          'Doğrulayıcı uygulamayla altı haneli kod. Dernek isterse bütün yöneticiler için zorunlu kılar; kurtarma kodları bir kez gösterilir.',
      },
      {
        baslik: 'Denetim kaydı',
        aciklama:
          'Kim, ne zaman, neyi değiştirdi. Kayıtlar silinemez ve düzenlenemez; denetim kurulu salt okunur erişir.',
      },
      {
        baslik: 'Sağlayıcı anahtarları şifreli',
        aciklama:
          'Ödeme ve SMS anahtarları veritabanında iki katmanlı şifreyle saklanır; panel yalnızca son dört karakteri gösterir.',
      },
      {
        baslik: 'Oturum güvenliği',
        aciklama:
          'Kısa ömürlü erişim jetonu, her kullanımda dönen yenileme jetonu. Çalınan jeton ikinci kez kullanılınca bütün oturum düşer.',
      },
      {
        baslik: 'Saklama ve imha',
        aciklama:
          'Ayrılan üyenin verisi yasal süre boyunca saklanır, sonra imha edilir. Süreler ve gerekçeleri belgelidir.',
      },
      {
        baslik: 'Yedek ve sürüm',
        aciklama:
          'Günlük yedek, ayrı bölgede saklama, geri yükleme tatbikatı. Hangi sürümün yayında olduğu her an doğrulanır.',
      },
    ],
    senaryo: {
      baslik: 'Sayman ayrılınca',
      metin: [
        'Başkan panelden saymanın erişimini kapatır; bütün cihazlardaki oturumları aynı anda düşer.',
        'Yeni sayman davetle gelir, şifresini kendisi belirler; ikinci adım kurulmadan panel açılmaz.',
        'Denetim kurulu, devir sürecinde kimin hangi kaydı değiştirdiğini denetim kaydından okur.',
      ],
    },
    mockup: 'guvenlik',
    sss: [
      {
        soru: 'Veriler nerede tutuluyor?',
        cevap:
          'Türkiye’de, bize ait sunucularda. Yedekler ayrı bir konumda şifreli saklanır. Veri işleme sözleşmesi aboneliğin parçasıdır.',
      },
      {
        soru: 'Sözleşme bitince verimizi alabilir miyiz?',
        cevap:
          'Evet. Üye, aidat, ödeme ve içerik verinizi açık biçimlerde dışa aktarırsınız. Veri doksan gün saklanır, sonra imha edilir.',
      },
      {
        soru: 'Sızma testi yapılıyor mu?',
        cevap:
          'Her sürümde otomatik bağımlılık ve sır taraması; bağımsız sızma testi Kurumsal müşterilerle paylaşılır.',
      },
    ],
    iliskili: ['uye-yonetimi', 'muhasebe-ve-raporlar', 'kurullar-ve-genel-kurul'],
  },
]

export const MODUL_HARITASI = new Map(MODULLER.map((m) => [m.slug, m]))

export function modulBul(slug: string): Modul {
  const m = MODUL_HARITASI.get(slug)
  if (!m) throw new Error(`Modül yok: ${slug}`)
  return m
}

/** Rozet metni; hazır olan modülde rozet yok. */
export const DURUM_ETIKETI: Record<Modul['durum'], string | null> = {
  hazir: null,
  gelistiriliyor: 'Geliştiriliyor',
  planlandi: 'Yakında',
}

export { BadgeCheck }
